module.exports = __webpack_public_path__ + "img/bannerBlue.69b4afd6.png";